import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  prompt: z.string().optional(),
})

export const Route = createFileRoute('/_protected/studio/new')({
  validateSearch: searchSchema,
  component: lazyRouteComponent(
    () => import('@/pages/studio-mock/builder/page'),
    'StudioBuilderPage',
  ),
})
